import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

// Guards the /sso route: only lets someone in if they're arriving with a
// fresh SSO handoff token (?t=...) or are already an established SSO
// session (localStorage sso_user flag set by sso-landing.component.ts).
// A normal logged-in user navigating here directly gets sent back to their
// regular service page instead of seeing the SSO-only experience.
@Injectable({ providedIn: 'root' })
export class SsoGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const hasFreshToken = !!route.queryParamMap.get('t');
    const isSsoUser = localStorage.getItem('sso_user') === 'true';

    if (hasFreshToken || isSsoUser) {
      return true;
    }

    this.router.navigate(['/home/servicePage']);
    return false;
  }
}
